// 路由name 唯一维护
export enum RouterName {
  LOGIN = "login",
  WEIXIN_PAGE = "WEIXIN_PAGE",
  WEIXIN_PAY = "WEIXIN_PAY",
  WEIXIN_API_PAY = "WEIXIN_API_PAY",
  DOWNLOAD = "DOWNLOAD",
  PAYMENT = "PAYMENT",
  PAYMENTRESULT = "PAYMENTRESULT",
  SETTING = "SETTING",
  ABOUT = "ABOUT",
  // 客户端路由 start
  PUBLISH_DATA = "publishData",
  MY_DATA = "myData",
  EDIT_DATA_DETAIL = "EDIT_DATA_DETAIL",
  EDIT_API_DATA_DETAIL = "EDIT_API_DATA_DETAIL",
  MY_ORDER = "MY_ORDER",
  ORDER_DETAIL = "ORDER_DETAIL",
  API_ORDER_DETAIL = "API_ORDER_DETAIL",
  GUIDANCE_DETAIL = "GUIDANCE_DETAIL",
  USER_GUIDANCE = "USER_GUIDANCE",
  CALLBACK = "CALLBACK",
  CLICALLBACK = "CLI_CALLBACK",
  CLIENT_CALLBACK = "CLIENT_CALLBACK",
  MY_API = "MY_API",
  MY_TRADE = "MY_TRADE",
  MY_REPORT = "MY_REPORT",
  // 客户端路由 end
  // 入口页
  ENTRANCE = "entrance",
  // 欢迎页
  WELCOME = "welcome",
  // 数据加密
  ENCRYPTION = "encryption",
  // 数据托管
  TRUST = "trust",
  // 推荐页面
  RECOMMEND = "recommend",
  // 有求必应
  RESPONSIVE = "community",
  // 活动详情
  STORY = "story",
  // 数据市场
  DATA_MARKET = "dataMarket",
  // 数据市场详情
  DATA_DETAIL = "dataDetail",
  // api数据市场详情
  API_DATA_DETAIL = "apiDataDetail",
  NOT_FOUND = "NotFound",
  // 发布数据
  PUBLISH_DATA_WEB = "publishDataWeb",
  TREND = "trend",
  // 我的订单
  ORDER_LIST = "orderList",
  // 个人中心
  USER_CENTER = "userCenter",
  // CSV模板
  TEMPLATE_CSV = "templateCsv",
  // video模板
  TEMPLATE_VIDEO = "templateVideo",
  // 文本模板
  TEMPLATE_TEXT = "templateText",
  QUALITY_REPORT = "QUALITY_REPORT",
  // 我的审核
  MY_REVIEW = "review",
  // 我的消息
  MY_MESSAGE = "myMessage",
  // 开户
  OPEN_PERSONAL_ACCOUNT = "openPersonalAccount",
  // 首页
  HOME = "home",
  // 首页
  PREVALIDATE = "prevalidate",
  // 用户协议
  USER_PROTOCOL = "USER_PROTOCOL",
  // 隐私政策
  PRIVACY_POLICY = "PRIVACY_POLICY",
  // 商户协议
  MERCHANT_PROTOCOL = "MERCHANT_PROTOCOL",
}
